module.exports = __webpack_public_path__ + "static/img/logo-cme.5be4267.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-cme.png
// module id = XQ0K
// module chunks = 1